import React from 'react'
import hand from '../../Image/handstar.svg'
import project from '../../Image/project.svg'
import experience from '../../Image/experiance.svg'
import developer from '../../Image/developer.svg'

const Last = () => {
   const lastDetail = [
      {image: hand ,title:'400+ Happy Client'},
      {image: project ,title:'600+ PROJECT COMPLETED'},
      {image: experience ,title:'7 YEARS+ EXPERIENCE'},
      {image: developer ,title:'30+ DEVELOPERS'},
   ]
  return (
    <div className='pb-[40px]'>
        <div className='container'>
          <div className='flex flex-wrap 2xl:flex-nowrap items-stretch'>
            {lastDetail?.map((item,id)=>{
               return(
                  <div className='2xl:w-1/4 md:w-1/2 w-full  px-2 mt-5' data-aos="fade-down" data-aos-duration={`${id + 10}00`}>
                  <div className='shadow-purple-md bg-white rounded-[10px] px-3 py-4 h-full flex items-center'>
                      <div className='flex items-center'>
                          <div className='sm:min-w-[90px] min-w-[70px]'>
                             <img src={item.image} alt="" className='sm:w-[90px] w-[70px]' />
                          </div>
                          <div className=''>
                             <p className='sm:text-[22px] sx:text-[20px] text-[18px] font-[700] ms-2 text-[#000000B2]'>{item.title}</p>
                          </div>
                      </div>
                  </div>
               </div>
               )
            })}

            
          </div>
        </div>
    </div>
  )
}

export default Last
